import React from 'react';

// Same control in both editing modes. The panel remains owned by its editor.
export default function FindSelectsButton({open,onToggle,available,disabled=false,buttonRef,label='Find selects',title='Find useful interview passages with AI'}){
  return <button className="find-selects-button" ref={buttonRef} type="button"
    disabled={disabled || !available} aria-expanded={open}
    aria-controls="editor-find-selects-panel" title={title}
    onClick={onToggle}>
    <span className="ai-badge" aria-hidden="true">AI</span> {label}
  </button>;
}
